
import { defineComponent } from "vue";
import { MyQuestion } from "@/views/MyQuaire";

export default defineComponent({
  name: "VueSingleSelect",
  props: {
    activeQuestion: { type: Object as () => MyQuestion, required: true },
  },
});
